import React from 'react';
import './components/style.css';
import { BrowserRouter, Routes, Route,Link, Navigate } from "react-router-dom";
import About from './components/AboutMe';
import Project from './components/Assignment';
import Header from './components/Header';
import Footer from './components/Footer';
import QRCODE from './components/QRCODE';
import Home from './components/Home'
import { hydrate, render } from "react-dom";
 


const App = () => {
  return (
   <>
 <BrowserRouter>
     <Header/>
     <Routes>
            <Route exact path="/" element={<Home/>} />
            <Route exact path="about" element={<About/>} />
            <Route exact path="projects" element={<Project/>} />
            <Route exact path='qr' element={<QRCODE/>}/>
            <Route path='*' element={<Home/>}/>

    </Routes>
</BrowserRouter>
<br/><br/><br/><br/><br/>
  
  <div className='footer_contain'>
    <br/>
  <Footer/>
  <br/>
  
  </div>

</>
);
};

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

export default App;